import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {
  RequestApproveDto,
  ListApprovalDto,
  ResponseListApprovalDto,
  ResponseApproveDto,
} from "../dto/request-inbox.dto";

@Injectable()
export class RequestInboxIntegratedApi {

  private service: string = '';
  private model: string = 'sf6s';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public approve(payload: RequestApproveDto): Observable<ResponseApproveDto> {
    const method: string = 'GET';
    const func: string = 'requestInbox/approve';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseApproveDto>(method, url, func, params, body, null, (10 * 60) * 1000);
  }
  
  public loanApprove(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'requestInbox/approveClaim';
    const params: any = payload || {};
    const urlParams: any =  {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body, contentType, (10 * 60) * 1000);
  }

  public approveClaim(formData): Observable<ResponseApproveDto> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'requestInbox/approveClaim';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseApproveDto>(method, url, params, urlParams, body, contentType, (10 * 60) * 1000);
  }

  public listApproval(payload: ListApprovalDto): Observable<ResponseListApprovalDto> {
    const method: string = 'GET';
    const func: string = 'requestInbox/listApproval';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseListApprovalDto>(method, url, func, params, body, null, (10 * 60) * 1000);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/request-inbox.api.ts